<script lang="ts">
import {defineComponent} from 'vue'
import Card from 'primevue/card'
import {useThemeStore} from "@/stores/theme.store"

export default defineComponent({
  name: 'LoginContainer',
  components: {
    Card,
  },
  props: {
    isLoading: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      logoDark: process.env.VUE_APP_LOGO_DARK,
      logoLight: process.env.VUE_APP_LOGO_LIGHT,
      themeStore: useThemeStore(),
    }
  },
});
</script>

<template>
  <Card class="login_container">
    <template #title>
      <img v-if="logoDark && themeStore.getTheme === 'dark'" :src="logoDark" alt="logo"/>
      <img v-else-if="logoLight && themeStore.getTheme === 'light'" :src="logoLight" alt="logo"/>
      <span v-else>{{ $t('app.name') }}</span>
    </template>
    <template #content>
      <div v-if="isLoading" style="text-align: center">
        <i class="pi pi-spin pi-spinner loader" ></i>
      </div>
      <slot v-else>
      </slot>
    </template>
  </Card>
</template>

<style scoped lang="scss">
.login_container{
  max-width: 25rem;
  margin: 3rem auto 0;
}
.login_container:deep(.p-card-title){
  text-align: center;
  margin-bottom: 2rem;
  img{
    height: 3rem;
  }
}
@media screen and (max-width: 450px) {
  .login_container{
    margin: 3rem 1rem 0;
  }
}
</style>